(() => {
  function buybackWizard(form) {
    const root = form.querySelector('[data-buyback-fields]');
    if (!root || form.querySelector('.mp-service__errors, .mp-service__success')) return;
    const steps = [...root.querySelectorAll('[data-buyback-step]')];
    const progress = root.querySelector('[data-buyback-progress]');
    const navigation = root.querySelector('[data-buyback-navigation]');
    const back = root.querySelector('[data-buyback-back]');
    const next = root.querySelector('[data-buyback-next]');
    const submit = form.querySelector('button[type="submit"]');
    const privacy = form.querySelector('.mp-service__privacy');
    const status = root.querySelector('[data-buyback-status]');
    const review = root.querySelector('[data-buyback-review]');
    let current = 0;
    function show(index, focus = true) {
      current = index;
      steps.forEach((step, i) => {
        step.hidden = i !== index;
        // Native validation must only see the current step until the final review.
        // Re-enable every field for the real Shopify submission so no answers are lost.
        step.querySelectorAll('input, select, textarea').forEach(field => { field.disabled = index !== steps.length - 1 && i !== index; });
      });
      [...progress.children].forEach((item, i) => {
        if (i === index) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
        item.classList.toggle('is-complete', i < index);
      });
      back.hidden = index === 0;
      next.hidden = index === steps.length - 1;
      submit.hidden = index !== steps.length - 1;
      privacy.hidden = index !== steps.length - 1;
      status.textContent = `Step ${index + 1} of ${steps.length}`;
      if (index === 2) {
        review.replaceChildren();
        for (const name of ['Device type', 'Model', 'Specifications', 'Condition', 'Powers on', 'Account lock', 'body']) {
          const field = form.elements.namedItem(`contact[${name}]`);
          if (!field?.value) continue;
          const row = document.createElement('div');
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = name === 'body' ? 'Faults / repair notes' : name; value.textContent = field.value;
          row.append(label, value); review.append(row);
        }
        review.hidden = false;
      }
      if (focus) {
        steps[index].querySelector('legend').focus({ preventScroll: true });
        form.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
    function valid(index) {
      const invalid = [...steps[index].querySelectorAll('input, select, textarea')].find(field => !field.checkValidity());
      if (!invalid) return true;
      show(index); invalid.focus(); invalid.reportValidity(); return false;
    }
    next.addEventListener('click', () => { if (valid(current)) show(current + 1); });
    back.addEventListener('click', () => show(Math.max(0, current - 1)));
    form.addEventListener('submit', event => {
      if (current < 2) { event.preventDefault(); event.stopImmediatePropagation(); if (valid(current)) show(current + 1); return; }
      for (let index = 0; index < steps.length; index++) {
        if (!valid(index)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      }
      // Allow the original Shopify contact form (and its spam protection) to submit.
    }, true);
    form.noValidate = false;
    progress.hidden = false; navigation.hidden = false;
    show(0, false);
  }
  function initialise(root) {
    root.querySelectorAll('.mp-service__form').forEach((form) => {
      if (form.dataset.deviceServiceReady) return;
      form.dataset.deviceServiceReady = 'true';
      buybackWizard(form);
      const start = form.querySelector('[data-rental-start]');
      const end = form.querySelector('[data-rental-end]');
      if (start && end) {
        const validate = () => {
          end.min = start.value || '';
          end.setCustomValidity(start.value && end.value && end.value < start.value
            ? 'Please choose a return date on or after the start date.' : '');
        };
        start.addEventListener('input', validate);
        end.addEventListener('input', validate);
        validate();
      }
      const message = form.querySelector('.mp-service__success, .mp-service__errors');
      if (message) {
        message.setAttribute('tabindex', '-1');
        message.focus({ preventScroll: true });
        form.scrollIntoView({ block: 'start' });
      }
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
